<template>
  <div class="filter-attr">
    <div>
      <el-tabs class="header" :stretch="true">
        <el-tab-pane label="筛选选项属性" :autofocus="true"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="filter-content">
      <el-form label-position="left" label-width="85px" :model="filter" ref="filterForm">
        <el-row>
          <el-col :span="24">
            <label class="el-form-item__label">是否必填</label>
            <el-switch v-model="filter.required" />
          </el-col>
        </el-row>
        <el-form-item label="筛选名称" label-width="none">
          <el-input  v-model="filter.name"/>
        </el-form-item>
        <el-form-item label="列宽" label-width="none" v-if="filter.dataType==='text'">
            <el-input-number v-model="filter.width" :min="1" :max="4"></el-input-number>
        </el-form-item>
        <el-form-item label="筛选类型" label-width="none">
          <el-select v-model="filter.dataType" placeholder="请选择" filterable @change="changeDataType">
            <el-option label="文本" value="text"></el-option>
            <el-option label="下拉" value="enum"></el-option>
            <el-option label="日期" value="date"></el-option>
            <el-option label="日期时间" value="datetime"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否多选" label-width="none" v-if="filter.dataType === 'enum'">
            <el-checkbox v-model="filter.multipleChoice" />
        </el-form-item>
        <template v-if="filter.dataType === 'enum'">
          <el-form-item label="设置选项"></el-form-item>
          <div class="setting-options">
            <div class="static">
              <el-form-item label="固定选项" label-position="left" label-width="75px">
                <el-switch v-model="filter.template.enable"></el-switch>
              </el-form-item>
              <template v-if="filter.template.enable">
                <el-form-item label="选项" label-width="75px">
                  <el-input type="textarea"
                            rows="5"
                            v-model="filter.template.stringOptions">
                  </el-input>
                </el-form-item>
              </template>
            </div>

            <div class="dataSource">
              <el-form-item label="关联数据源" label-width="75px">
                <el-switch v-model="filter.dataSource.enable"></el-switch>
              </el-form-item>
              <template v-if="filter.dataSource.enable">
                <el-form-item label="辅助表">
                  <el-select v-model="filter.dataSource.reportId" placeholder="请选择" filterable clearable
                             @change="changeDateReportId">
                    <el-option
                      v-for="item in dataSourceReports"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="选项ID">
                  <el-select v-model="filter.dataSource.columnId" filterable clearable>
                    <el-option
                      v-for="item in columns"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="选项文本">
                  <el-select v-model="filter.dataSource.showColumnId" filterable clearable>
                    <el-option
                      v-for="item in columns"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-for="filter in filters" :label="filter.name" :key='filter.columnId'>
                  <el-select v-model="filter.defaultValue" filterable clearable @change="changeFilter(filter)">
                    <el-option
                      v-for="item in getOrdinaryFilter"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="远程搜索">
                  <el-checkbox v-model="filter.dataSource.remote"></el-checkbox>
                </el-form-item>
              </template>
            </div>

          </div>
        </template>
        <el-form-item label="比较类型" label-width="none">
          <el-select v-model="filter.type" placeholder="请选择">
            <el-option label="等于" value="EqualsTo"></el-option>
            <el-option label="大于等于" value="GreaterThanEquals"></el-option>
            <el-option label="小于等于" value="MinorThanEquals"></el-option>
            <el-option label="包含" value="LikeExpression"></el-option>
            <el-option label="大于" value="GreaterThan"></el-option>
            <el-option label="小于" value="MinorThan"></el-option>
            <el-option label="不等于" value="NotEqualsTo"></el-option>
            <el-option label="空" value="IsNull"></el-option>
            <el-option label="非空" value="IsNotNull"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="input default" label="默认值" label-width="none">
          <div class="formula"
               v-if="filter.dataType.includes('date')"
               v-html="filter.defaultValue"
               @click="openCalculation()"></div>
          <el-select
            v-else-if="filter.dataType === 'enum'"
            v-model="filter.defaultValue"
            placeholder="请选择" filterable>
            <el-option
              v-for="(item,index) in selectData"
              :key="index"
              :label="item.value"
              :value="item.id">
            </el-option>
          </el-select>
          <el-input v-else v-model="filter.defaultValue"/>
        </el-form-item>
        <el-form-item label="筛选列" label-width="none">
          <el-select class="multiple-select" v-model="filter.columnId" multiple :multiple-limit="10" collapse-tags clearable filterable placeholder="请选择">
            <el-option
              v-for="column in this.reportService.report.columns.concat(this.allReportFilters)"
              :key="column.id"
              :label="column.name"
              :value="column.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="筛选模式" label-width="none" v-if="this.reportService.report.groupByEnable">
          <el-select class="multiple-select" v-model="filter.filterType"  placeholder="请选择">
            <el-option label="基础筛选"  value="ordinary">  </el-option>
            <el-option label="分组筛选"  value="having">  </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示语" label-width="none">
          <el-input v-model="filter.placeholder" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item v-if="filter.dataType === 'enum'" label="更多模式" label-width="none">
          <el-select v-model="filter.moreType" placeholder="请选择" clearable>
            <el-option label="树状模式" value="tree"></el-option>
            <el-option label="勾选模式" value="check"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实时搜索" label-width="65px">
          <el-checkbox v-model="filter.immediate"></el-checkbox>
        </el-form-item>
      </el-form>
    </div>

    <div class="buttons">
      <el-button type="primary" @click="saveAttr">保存</el-button>
      <el-button @click="closeAttr">关闭</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import cache from '../../public/cache'
export default {
  name: 'filter-panel',
  inject: ['reportService', 'needLoad'],
  data () {
    let id = this.reportService.options.leftPanel.id
    const filter = this.$_.cloneDeep(this.reportService.report.filters.find(m => m.id === id))
    filter.columnId = filter.columnId.split('|')
    return {
      filter: filter,
      selectData: [],
      columns: [],
      filters: [],
      allReportFilters: []
    }
  },
  async created () {
    const type = ['enum', 'date', 'datetime']
    if (!type.includes(this.filter.dataType.toLowerCase())) {
      this.filter.dataType = 'text'
    }

    await this.loadData()
    this.loadAllFilters()
    if (this.filter.dataType.toLowerCase() === 'enum') {
      this.filter.type = this.filter.type || 'EqualsTo'
      this.filter.placeholder = '请选择'
    }
    this.filter.dataType = this.filter.dataType.toLowerCase()
  },

  methods: {
    loadAllFilters () {
    // 加载从表是辅助表筛选项
      this.reportService.report.joins.map(m => {
        if (m.joinType && m.joinType !== 'archived') {
          let dataSourceReport = _.cloneDeep(this.reportService.options.dataSourceReports.find(n => n.id === m.referenceTableId))
          if (dataSourceReport) {
            dataSourceReport.filters.forEach((m) => {
              m.name = dataSourceReport.name + '-' + m.name
              this.allReportFilters.push(m)
            })
          }
        }
      })
    },
    saveAttr () {
      this.filter.columnId = this.filter.columnId.join('|')
      // 保存的时候清空没用的数据
      if (this.filter.dataSource.enable) {
        this.filter.template.stringOptions = ''
      } else {
        this.filter.dataSource.reportId = ''
        this.filter.dataSource.columnId = ''
        this.filter.dataSource.showColumnId = ''
      }
      this.reportService.createOrUpdate(this.filter)
      this.closeAttr()
    },
    closeAttr () {
      this.reportService.closePanel()
    },

    changeDataType (val) {
      this.filter.type = 'EqualsTo'
      if (val === 'enum') {
        this.filter.placeholder = '请选择'
        this.loadData()
      } else {
        this.filter.placeholder = ''
        this.filter.multipleChoice = false
      }
    },
    changeDateReportId (val) {
      this.filter.dataSource.columnId = ''
      this.filter.dataSource.showColumnId = ''
    },
    clearDefaultValue () {
      this.filter.defaultValue = ''
    },
    loadSelectData () {
      this.selectData = []
      // 给默认值的下拉框赋值
      if (this.filter.template.enable) {
        this.selectData = this.filter.template.stringOptions && this.filter.template.stringOptions.trim().split('\n').map(m => {
          return {value: m, id: m}
        })
      } else {
        let dataSource = this.filter.dataSource
        if (dataSource.reportId && dataSource.columnId && dataSource.showColumnId) {
          let params = {'index': 1, 'size': 50}
          cache.getData(`/report-api/report/data/${dataSource.reportId}`, params).then((data) => {
            this.selectData = data.map(n => {
              return {id: n[dataSource.columnId], value: n[dataSource.showColumnId]}
            })
          })
        }
      }
    },
    loadData () {
      let that = this
      let column = this.reportService.report.columns.find(n => n.id === this.filter.columnId[0])
      if (column && column.columnId) {
        cache.getDateWithNoparma(`/form-api/components/component/properties?columnId=${column.columnId}`).then((data) => {
          // 原来就是下拉框控件
          if (data.dataSource) {
            that.filter.dataSource.reportId = that.filter.dataSource.reportId || data.dataSource.reportId
            that.filter.dataSource.columnId = that.filter.dataSource.columnId || data.dataSource.columnId
            that.filter.dataSource.showColumnId = that.filter.dataSource.showColumnId || data.dataSource.showColumnId
            that.filter.template.stringOptions = that.filter.template.stringOptions || data.template.stringOptions
          } else {
            that.filter.template.stringOptions = that.filter.template.stringOptions || '选项1\n选项2\n选项3'
          }
          if (that.filter.dataSource.enable) {
            that.loadReportColumns(that.filter.dataSource.reportId)
          } else if (that.filter.template.enable) {
            this.filter.template.stringOptions = this.filter.template.stringOptions || '选项1\n选项2\n选项3'
            that.loadSelectData()
          }
        })
      }
    },

    loadReportColumns (val) {
      if (val) {
        this.columns = []
        this.filters = []
        let dataSourceReport = {}
        this.reportService.loadDataReport(val).then(() => {
          dataSourceReport = this.reportService.options.dataSourceReports.find(m => m.id === val)
          dataSourceReport.columns.forEach(n => {
            this.columns.push(_.pick(n, ['name', 'id']))
          })
          dataSourceReport.filters.forEach(m => {
            if (m.filterType !== 'senior') {
              if (this.filter.dataSource.filter) {
                m.defaultValue = this.filter.dataSource.filter[m.id]
              } else {
                this.filter.dataSource.filter = {}
              }
              this.filters.push(_.pick(m, ['id', 'name', 'columnId', 'defaultValue']))
            }
          })
        })
      }
    },
    changeFilter (filter) {
      if (!this.filter.dataSource.filter) {
        this.filter.dataSource.filter = {}
      }
      this.filter.dataSource.filter[filter.id] = filter.defaultValue
    },
    openCalculation () {
      this.$Popup.calculation({
        parameter: {
          expression: this.filter.defaultValue,
          dataSource: [],
          dataSourceEnable: false
        },
        width: '1000px'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          this.filter.defaultValue = data.value
        }
      })
    }

  },
  computed: {
    allFilters () {
      return this.reportService.report.columns.concat(this.allReportFilters)
    },
    dataSourceReports () {
      return this.reportService.options.dataSourceReports
    },
    getOrdinaryFilter () {
      return this.reportService.report.filters.filter(m => m.filterType === 'ordinary' || m.filterType === 'having')
    },
    getNeedLoad () {
      return this.needLoad.value
    }
  },
  watch: {
    getNeedLoad: {
      handler (val) {
        if (val > 0) {
          // this.loadAllFilters()
        }
      },
      deep: true,
      immediate: true
    },
    'filter.type' (val) {
      if (val !== 'LikeExpression') {
        this.filter.columnId = this.filter.columnId.slice(0, 1)
      }
    },
    'filter.dataType' (val) {
      if (val !== 'text') {
        this.filter.columnId = this.filter.columnId.slice(0, 1)
      }
    },
    'filter.dataSource': {
      handler (val) {
        val.reportId && this.loadReportColumns(val.reportId)
        if (val.enable && val.reportId && val.showColumnId && val.columnId) {
          this.loadSelectData()
        }
        if (!val.enable) this.filter.dataSource.remote = false
        this.filter.template.enable = !val.enable
        this.clearDefaultValue()
      },
      deep: true
    },
    'filter.template.enable' (val) {
      if (val) this.clearDefaultValue()
      this.loadSelectData()
      this.filter.dataSource.enable = !val
    },
    'filter.template.stringOptions' (val) {
      if (this.filter.template.enable) this.clearDefaultValue()
      this.loadSelectData()
    }
  }
}
</script>

<style lang="scss">
  .filter-attr {
    height: 100%;
    .filter-content {
      height: 80%;
      padding-left: 26px;
      padding-right: 27px;
      margin-top: -15px;
      overflow: hidden;
      overflow-y: auto;
      // 多选下拉框的样式
      .multiple-select.el-select {

        >div.el-select__tags {
          width: 100%;

          >span {
            display: flex;
            width: 90%;

            >span:nth-child(1) {
              display: flex;
              width: 100%;

              .el-select__tags-text {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .el-icon-close {
                width: 18px;
                top: 4px;
              }
            }
          }

          .el-select__input {
            display: none;
          }
        }

      }
      form {
        .el-form-item {
          margin-top: 6px;
          margin-bottom: 6px;
        }
        .el-form-item__content {
          width: 195px;
          .el-input {
            width: 195px;
            .el-input__inner {
              width: 195px;
            }
          }
        }
        .el-select {
          width: 182px;
        }
        .dataSource {
          .el-select {
            width: 72px;
          }
        }
        .setting-options {
          border: 1px solid #c2c3c4;
          padding-left: 10px;
          padding-right: 10px;
          width: 195px;
          .formula {
            position: absolute;
            margin-top: -14px;
            padding: 0 10px;
            top: 50%;
            outline: none;
            border: 1px solid #e4e7ed;
            background: #fff;
            border-radius: 4px;
            max-height: 80px;
            overflow: hidden;
            width: 100%;
            height: 28px;
            line-height: 28px;
            text-align: left;

            code {
              padding: 2px 4px;
              font-size: 90%;
              color: #c7254e;
              background-color: #f9f2f4;
              border-radius: 4px;
            }
          }
          .el-form-item {
            .el-form-item__content {
              width: auto;
              .el-select, .el-input {
                width: 72px;
                .el-input__inner {
                  width: 72px;
                }
              }
            }
          }
        }
        >.el-row {
          >div {
            margin-top: 8px;
          }
          .el-switch {
            float: right;
            top:2px;
          }
        }
        .el-form-item {
          .el-form-item__content {
            input.el-input__inner{
              height: 28px;
              line-height: 28px;
              border: 1px solid #c2c3c4;
            }
            .el-input-number--mini {
              width: 100%;
            }
          }
        }
        label.el-form-item__label {
          height: 28px;
          line-height: 28px;
          font-size: 12px;
          padding-bottom: 0;
        }
        .el-date-editor {
          width: 100%;
        }
        .default{
          .formula {
            text-align: left;
            margin-top: -14px;
            padding: 0 10px;
            top: 50%;
            outline: none;
            border: 1px solid #e4e7ed;
            background: #fff;
            border-radius: 4px;
            max-height: 80px;
            overflow: hidden;
            width: 100%;
            height: 28px;
            line-height: 28px;
          }
        }
      }
    }
    .header {
      .el-tabs__nav-wrap {
        background-color: #ebf6ff;
      }
    }
    .buttons {
      height: 10%;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      background: #fff;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      button{
        width: 72px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/filter-panel.vue